<!-- 公共底部 -->
<template>
    <div class="footer_wrap">

        <div class="left">
            <!-- <img src="../assets/imgs/footerlogo.png" alt=""> -->
            <span>{{$t("footers.orgname")}}</span>
        </div>

        <ul class="right">
            
            <li>{{$t("footers.address")}}</li>
            <li>{{$t("footers.email")}}</li>
            <li>Copyright © {{year}}
                <img src="../assets/imgs/copy_n.png" alt="">
                <a href="https://beian.miit.gov.cn" target="_blank">京ICP备15054044号-1</a>

            </li>
        </ul>
    </div>
</template>

<script>
export default {
    data() {
        return {
            year: new Date().getFullYear(), //当前年份
        };
    },
};
</script>
<style scoped lang='less'>
.footer_wrap {
    display: flex;
    height:70px;

    justify-content: center;
    align-items: center;
    background: #3D4454;
}
.left {
    // width: 125px;
    margin-right: 30px;
    color: #f4f4f4;
    img {
        width: 100%;
        height: 100%;
    }
    li + li {
        margin-top: 14px;
    }
}
.right {
    border-left: 2px solid #c5c2c2;
    padding-left: 30px;
    color: #fff;
    font-size: 10px;
    a {
        color: #fff;
    }
    li + li {
        line-height: 20px;
    }
    img {
        width: 20px;
        vertical-align: middle;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/ComFooter.vue